import { createFileRoute } from "@tanstack/react-router";
import { InboxIcon } from "lucide-react";
import { RequestsInbox } from "@/components/dashboard/requests-inbox";
import { DEFAULT_HR_REQUEST_FILTERS, hrRequestsPageQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/requests")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(
      context.queryClient.ensureInfiniteQueryData(hrRequestsPageQuery(DEFAULT_HR_REQUEST_FILTERS)),
    );
  },
  component: RequestsPage,
});

function RequestsPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <InboxIcon className="size-3.5" />
            Requests
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Employee requests</h1>
          <p className="text-muted-foreground text-sm">
            Review and decide on document and profile-update requests from your team. For time off,
            use the Leave menu.
          </p>
        </div>

        <RequestsInbox />
      </div>
    </main>
  );
}
